<template>
	<div>
		<div class="qualified">
			<div class="details-title">
				<div>{{name}}</div>
				<div></div>
			</div>
			<el-row :gutter="30" v-loading="loading">
				<el-col :span="24">
						<el-table class="qcTable scrollbar" :data="dataList">
							<el-table-column prop="TotalRank" label="排名" :key="1"></el-table-column>
							<el-table-column prop="DoctorName" label="姓名" :key="2"></el-table-column>
							<el-table-column prop="HospitalName" show-overflow-tooltip label="影像中心" :key="3">
								<template slot-scope="scope">
									{{scope.row.HospitalName }}
								</template>
							</el-table-column>
							<el-table-column prop="AvgScore" label="平均分" :key="4"></el-table-column>
							<el-table-column prop="" label="操作" :key="5">
								<template slot-scope="scope">
									<span class="table-task-btn detail" @click="pAssessment(scope.row)">个人评估</span>
									<span class="table-task-btn detail" @click="qualifiedClick(scope.row,'qualified')">报告列表</span>
								</template>
							</el-table-column>
						</el-table>
				</el-col>
			</el-row>
			<div class="pages">
				<el-pagination class="pageAll" layout="prev, pager, next" :total="dataList.TotalCount" :page-size='getAvgScoreParameter.pageCount' :current-page='getAvgScoreParameter.pageIndex' @current-change='currentChange'>
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex'
	export default {
		data() {
			return {
				currentRow: null,
				height:0,
				datas:{},
				pageshow:true,
				dataList:[],
				name:''
			};
		},
		computed: {
			...Vuex.mapState('breadcrumb',['breadLists']),
			...Vuex.mapState('supervisor',['QualifiedPart','GetReportListArr','loading', 'breadcrumbList']),
			...Vuex.mapState('visualization',['getAvgScoreParameter','doctorsAvgScore','technicianAvgScore','visbreadcrumbList']),
		},
		activated(){
			let _this = this;
			let index = Number(this.breadLists.breadList.length);
			_this.GetDoctorsAvg();
			if(this.visbreadcrumbList[2] == 2){
				_this.breadLists.breadList[index - 1].name = '全国医生排名';
				_this.name = '全国医生排名';
			}else{
				_this.breadLists.breadList[index - 1].name = '全国技师排名';
				_this.name = '全国技师排名';
			}
		},
		methods: {
			...Vuex.mapMutations('breadcrumb', ['setTootipType', 'clearRow']),
			...Vuex.mapMutations('visualization', ['setvisBreadcrumbList']),
			...Vuex.mapMutations('supervisor', ['currentChangesSecond', 'settableLoading','setLoading','setBreadcrumbList']),
			...Vuex.mapActions('visualization', ['GetDoctorsAvgScore']),
			setPar(type){
				this.getAvgScoreParameter.type = type;
				this.getAvgScoreParameter.pageCount = 10;
			},
			GetDoctorsAvg(){
				let _this = this;
				if (this.visbreadcrumbList[2] == 2) {
					_this.setPar(2)
				}else{
					_this.setPar(3)
				}
				_this.setLoading(true);
				_this.GetDoctorsAvgScore().then(()=>{
					_this.setLoading(false);
					_this.dataList = _this.visbreadcrumbList[2] == 2?_this.doctorsAvgScore.Doctors:_this.technicianAvgScore.Doctors;
					_this.dataList.TotalCount = _this.visbreadcrumbList[2] == 2?_this.doctorsAvgScore.TotalCount:_this.technicianAvgScore.TotalCount;
				});
			},
			//合格医生点击
			qualifiedClick(row, type) {
				let previous = JSON.parse(JSON.stringify(this.visbreadcrumbList));
				this.setLoading(true);
				this.settableLoading(true);
				this.setTootipType(false);
				this.clearRow();
				this.currentChangesSecond(1);
				this.QualifiedPart.hospitalGuid = row.HospitalGuid;
				this.QualifiedPart.doctorName = row.DoctorName;
				this.QualifiedPart.type = type;
				this.setBreadcrumbList();
				this.GetReportListArr.type = "医生列表";
				this.GetReportListArr.name = '';
				this.GetReportListArr.tabType = previous[2];
				this.breadcrumbList.push(this.visbreadcrumbList[0]);
				this.breadcrumbList.push(row.DoctorName);
				this.breadcrumbList.push("doctor");
				this.$router.push("/home/supervisor/qualifiedTable");
			},
			//个人评估
			pAssessment(row){
				let previous = JSON.parse(JSON.stringify(this.visbreadcrumbList))
				this.setTootipType(false);
				this.clearRow();
				this.currentChangesSecond(1);
				this.setvisBreadcrumbList();
				this.visbreadcrumbList.push(previous[0]);
				this.GetReportListArr.type = row.DoctorName;
				this.visbreadcrumbList.push(row.DoctorName);
				this.GetReportListArr.name = row.DoctorName;
				this.GetReportListArr.hospitalGuid = row.HospitalGuid;
				this.GetReportListArr.DoctorGuid = row.DoctorGuid;
				this.visbreadcrumbList.push(previous[2]);
				this.$router.push("/home/visualization/visPersonalAssessment");
			},
			currentChange(val){
				this.getAvgScoreParameter.pageIndex = val;
				this.GetDoctorsAvg();
			}
		}

	}
</script>